
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"46"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FF7676","fill-rule":"evenodd","stroke":"#FF6B71","stroke-width":".2","d":"M48.754 18.181a1.01 1.01 0 00-.77-.355h-2.152V6.422c0-.782-.638-1.416-1.416-1.416H19.844l-1.99-3.317A1.409 1.409 0 0016.64 1H5.585c-.782 0-1.416.634-1.416 1.416v15.41H2.018a1.014 1.014 0 00-1.005 1.17L4.95 45.002c.078.5.5.864 1.006.864H44.04c.507 0 .93-.364 1.008-.868l3.94-26a1.018 1.018 0 00-.235-.818zM5.774 2.604h10.761l1.991 3.317c.254.423.72.69 1.217.69h24.485v11.215h-1.6v-5.61H7.372v5.61h-1.6V2.604zm3.203 15.222h32.047V13.82H8.977v4.006zM43.54 44.263H6.46L2.698 19.429h44.604L43.54 44.263z"}})])
          )
        }
      }
    